import { IPortalAuth, IPortalUserLoginAction } from "src/app/model/custom/IPortal";

export class PortalAuthValidatePortalKeyAction {
	static readonly type = "[PortalAuth] Validate Portal Key";
	constructor(public payload: IPortalAuth) {}
}

export class PortalAuthUserLoginAction {
	static readonly type = "[PortalAuth] User Login";
	constructor(public payload: IPortalUserLoginAction) {}
}

export class PortalAuthUserLogoutAction {
	static readonly type = "[PortalAuth] User Logout";
}
